import { APP_INITIALIZER } from '@angular/core';
import { AppInitializedAction } from '@app/app.actions';
import { Store } from '@ngrx/store';

export const provideAppInitializeAction = () => ({
  provide: APP_INITIALIZER,
  useFactory: (store: Store) => () => store.dispatch(AppInitializedAction()),
  deps: [Store],
  multi: true
});
